module.exports = __webpack_public_path__ + "static/media/5. Reacción, Lámina hierro y papel sobre madera, 90 x 160 cm, 2011 copy.9c9ffb35.png";